<template>
  <div>
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '供应商',
          url: '/shop',
        },
        {
          title: '供应商管理',
          active: true,
        },
      ]"
    ></vs-breadcrumb>

    <div class="vx-row w-full mb-3 mt-4">
      <div class="vx-col sm:w-1/5 flex" style="justify-content: flex-start">
        <vs-button @click="addStore">添加供应商</vs-button>
      </div>
      <div
        class="vx-col sm:w-4/5 flex"
        style="justify-content: flex-end; padding: 0 0"
      >
        <vs-input
          class="mr-2"
          v-model="searchParams.store_name"
          placeholder="搜索"
        />
        <vs-button @click="reserviseParam">搜索</vs-button>
      </div>
    </div>

    <vs-table
      ref="table"
      :notSpacer="false"
      :stripe="true"
      :max-items="itemsPerPage"
      :data="list"
      :noDataText="noDataText"
    >
      <template slot="thead">
        <vs-th style="min-width: 6rem">编号</vs-th>
        <vs-th width="15%"> 店铺logo </vs-th>
        <vs-th width="19%">店铺名称</vs-th>
        <vs-th>店铺管理员</vs-th>
        <vs-th>店铺商品数</vs-th>
        <vs-th>店铺订单数</vs-th>
        <vs-th>店铺订单总金额</vs-th>
        <vs-th>状态</vs-th>
        <vs-th>排序</vs-th>
        <vs-th>首页推荐</vs-th>
        <vs-th>海关推单</vs-th>
        <vs-th>操作</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p>{{ tr.id }}</p>
            </vs-td>
            <vs-td>
              <img
                :src="
                  tr.store_logo
                    ? tr.store_logo
                    : require('@/assets/images/placeholder/5x4.png')
                "
                class="w-1/3"
              />
            </vs-td>
            <vs-td>
              <p>{{ tr.store_name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.owner_name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.goodsCount }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.orderCount }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.orderTotalPrice }}</p>
            </vs-td>
            <vs-td>
              <p v-if="tr.is_publish">开启</p>
              <p v-else>关闭</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.sort }}</p>
            </vs-td>
            <vs-td>
              <ul class="con-s">
                <li>
                  <vs-switch
                    v-model="tr.is_recommend_boolean"
                    @input="changeSwitchOfRecommend(tr)"
                  />
                </li>
              </ul>
            </vs-td>
            <vs-td>
              <ul class="con-s">
                <li>
                  <vs-switch
                    v-model="tr.is_customs_push_boolean"
                    @input="changeSwitchOfCustomPush(tr)"
                  />
                </li>
              </ul>
            </vs-td>

            <!-- 操作 -->
            <vs-td class="whitespace-no-wrap">
              <div>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current a-hover"
                  @click.stop="editData(tr, indextr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current a-hover"
                  class="ml-2"
                  @click.stop="deleteData(tr.id)"
                />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination
      class="mt-6"
      :total="totalPage"
      v-model="currentx"
      @input="gotoCurrentPage"
    ></vs-pagination>

    <vs-popup title="删除供应商" :active.sync="delPopUpActive">
      <div class>
        <div class="mb-4">是否确认删除供应商？</div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="delConfirm" :disabled="btnDisabled"
              >确认删除</vs-button
            >
            <vs-button type="border" @click="closeDel" :disabled="btnDisabled"
              >关闭</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import storeRepo from '@/repo/store.js'
export default {
  data() {
    return {
      searchParams: {},
      noDataText: '',
      tr_id: null,
      page: 1,
      list: [],
      delPopUpActive: false,
      itemsPerPage: 5,
      totalPage: 0,
      currentx: 1,
      btnDisabled: false,
    }
  },
  mounted() {
    this.getStoreList()
  },
  methods: {
    reserviseParam: function () {
      if (this.searchParams.store_name.trim()) {
        this.getStoreList(this.searchParams)
      } else {
        this.getStoreList()
      }
    },
    delConfirm: function () {
      this.btnDisabled = true

      let that = this
      setTimeout(() => {
        that.delPopUpActive = false
      }, 700)
      storeRepo.deleteStore(that.tr_id, (error, resp) => {
        that.btnDisabled = false
        if (resp.code == 0) {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'success',
            title: '操作提示',
            text: resp.msg,
          })
          that.getStoreList()
        } else {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
    },
    closeDel: function () {
      this.delPopUpActive = false
    },

    gotoCurrentPage: function () {
      this.page = this.currentx
      this.getStoreList()
    },

    getStoreList: function (q) {
      if (q && !q.store_name) {
        q = {}
      }
      this.$vs.loading()
      const page = this.page
      const per_page = this.itemsPerPage
      let that = this
      storeRepo.list(page, per_page, q, (error, resp) => {
        that.$vs.loading.close()
        if (resp.code == 0) {
          resp.data.data.forEach((val) => {
            if (val.is_customs_push) {
              val.is_customs_push_boolean = true
            } else {
              val.is_customs_push_boolean = false
            }
            if (val.is_recommend) {
              val.is_recommend_boolean = true
            } else {
              val.is_recommend_boolean = false
            }
          })
          that.list = JSON.parse(JSON.stringify(resp.data.data))
          const total = resp.data.total
          const perCount = resp.data.per_page
          that.totalPage = Math.ceil(total / perCount)
          if (that.totalPage === 0) {
            that.noDataText = '数据为空'
          } else {
            that.noDataText = ''
          }
        }
      })
    },

    addStore: function () {
      this.$router.push({ name: 'shopCreate' })
    },

    changeSwitchOfRecommend: function (row) {
      let param = {}
      if (row.is_recommend_boolean) {
        param.is_recommend = 1
      } else {
        param.is_recommend = 0
      }
      let that = this
      storeRepo.changeSwitchOfRecommend(row.id, param, (error, resp) => {
        if (resp.code == 0) {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'success',
            title: '操作提示',
            text: resp.msg,
          })
        } else {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
    },

    editData: function (row) {
      this.$router.push({
        name: 'shopCreate',
        query: {
          id: row.id,
        },
      })
    },

    deleteData: function (id) {
      this.tr_id = id
      this.delPopUpActive = true
    },

    changeSwitchOfCustomPush: function (row) {
      let param = {}
      if (row.is_customs_push_boolean) {
        param.is_customs_push = 1
      } else {
        param.is_customs_push = 0
      }
      let that = this
      storeRepo.changeSwitchOfCustomPush(row.id, param, (error, resp) => {
        if (resp.code == 0) {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'success',
            title: '操作提示',
            text: resp.msg,
          })
        } else {
          that.$vs.notify({
            position: 'bottom-center',
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
